import React, { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import axiosInstance from "../../../../configuration/request";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../../../component/SnackbarContext";
import {
  removeCartItem,
  setCartItems,
  updateCartItem,
} from "../../../../Redux/Slices/customerSlice";
import TailoringTypeDropdown from "../../components/tailoringTypeDropdown";
import { serviceTypeValueToLabel } from "../../../../utils/orderPayload";

export default function TailoringAndDryClean() {
  const showSnackbar = useSnackbar();
  const { cartItems, orderFlow, selectedService, selectedShop } = useSelector(
    (state) => state.customer
  );
  const dispatch = useDispatch();

  const [category, setCategory] = useState([]);
  const [cloth, setCloth] = useState([]);
  const [tailoringType, setTailoringType] = useState([]);
  useEffect(() => {
    if (orderFlow === "shop") {
      fetchShopServices();
    } else {
      fetchServices();
    }
  }, []);

  const fetchShopServices = async () => {
    let service = serviceTypeValueToLabel(selectedService);
    const res = await axiosInstance.get(
      `/customer/services-offered/getServiceBasedonStore?store_id=${selectedShop?.id}&service_name=${service}`
    );

    const rawData = res?.data?.[1] || [];

    // Group by cloth_name
    const groupedData = Object.values(
      rawData.reduce((acc, item) => {
        const name = item.cloth_name;

        if (!acc[name]) {
          acc[name] = {
            name: name,
            category: [],
            description: item.description,
            deleted_at: item.deleted_at,
            tailoringType: [],
          };
        }

        // Add unique category
        if (item.category && !acc[name].category.includes(item.category)) {
          acc[name].category.push(item.category);
        }

        if (item?.tailoringType?.length > 0) {
          item?.tailoringType?.map((type) => {
            if (type && !acc[name]?.tailoringType.includes(type.name)) {
              acc[name]?.tailoringType.push(type.name);
            }
          });
        }
        return acc;
      }, {})
    );

    const initial = groupedData.map((data) => {
      const inCart = cartItems.find(
        (cartItem) => cartItem.name === data?.category
      );
      return {
        name: data?.name,
        category: inCart?.category || "",
        tailoring: inCart?.tailoringType || "",
        weight: inCart?.weight || 0,
        tailoringTypeOption: data?.tailoringType,
        categoryOption: data?.category,
      };
    });
    setCloth(initial);
  };

  const fetchServices = async () => {
    let tailoringData = [];
    const catData = await fetchDropdownData("cloth_category");
    setCategory(catData);

    if (selectedService === "Tailoring") {
      tailoringData = await fetchDropdownData("tailoring_type");
      setTailoringType(tailoringData);
    }

    const clothData = await fetchDropdownData("cloth_name");

    const initial = clothData.map((name) => {
      const inCart = cartItems.find((cartItem) => cartItem.name === name);
      return {
        name,
        category: inCart?.category || "",
        tailoringType: inCart?.tailoringType || "",
        weight: inCart?.weight || 0,
        tailoringTypeOption: tailoringData,
        categoryOption: catData,
      };
    });

    setCloth(initial);
  };

  const fetchDropdownData = async (label) => {
    try {
      const res = await axiosInstance.get(`/customer/core/dropdown/${label}`);
      return res?.data?.value || [];
    } catch (error) {
      console.error(`Failed to fetch data for ${label}:`, error);
      return [];
    }
  };

  const handleCategoryChange = (itemName, cat) => {
    setCloth((prev) =>
      prev.map((c) => (c.name === itemName ? { ...c, category: cat } : c))
    );
  };

  const handleTailoringTypeChange = (itemName, value) => {
    setCloth((prev) =>
      prev.map((c) =>
        c.name === itemName ? { ...c, tailoringType: value } : c
      )
    );
    const updatedItem = cloth.find((c) => c.name === itemName);
    if (updatedItem) {
      dispatch(
        updateCartItem({
          name: updatedItem.name,
          weight: updatedItem.weight,
          tailoringType: value,
          category: updatedItem.category,
        })
      );
    }
  };

  const handleAdd = (item) => {
    if (!item.category) {
      showSnackbar("Please select category before adding!", "error");
      return;
    }
    if (selectedService === "Tailoring" && item?.tailoringType.length <= 0) {
      showSnackbar("Please select tailoring before adding!", "error");
      return;
    }
    setCloth((prev) =>
      prev.map((c) => (c.name === item.name ? { ...c, weight: 1 } : c))
    );
    if (selectedService === "Tailoring") {
      dispatch(
        setCartItems({
          name: item.name,
          weight: 1,
          tailoringType: item.tailoringType,
          category: item.category,
        })
      );
    } else {
      dispatch(
        setCartItems({
          name: item.name,
          weight: 1,
          tailoringType: [],
          category: item.category,
        })
      );
    }
  };

  const handleQuantityChange = (itemName, delta) => {
    setCloth((prev) =>
      prev.map((c) => (c.name === itemName ? { ...c, weight: delta } : c))
    );
    const updatedItem = cloth.find((c) => c.name === itemName);
    if (updatedItem) {
      dispatch(
        updateCartItem({
          name: updatedItem.name,
          weight: delta,
          tailoringType: updatedItem.tailoringType,
          category: updatedItem.category,
        })
      );
    }
  };

  const isInCart = (name) => {
    if (cartItems) {
      return cartItems.some((i) => i.name === name);
    }
  };

  const handleRemove = (item) => {
    dispatch(removeCartItem({ name: item.name }));
    setCloth((prev) =>
      prev.map((cloth) =>
        cloth.name === item.name
          ? { ...cloth, weight: 0, category: "", tailoringType: "" }
          : cloth
      )
    );
  };

  return (
    <div className="space-y-4">
      {cloth.map((item, idx) => {
        const inCart = isInCart(item.name);
        return (
          <div
            key={idx}
            className={`border rounded-md
          ${
            inCart
              ? "border-[#D8DAE5] text-[#1876A9]"
              : "border-[#F6F6F6] text-[#242B33]"
          }`}
          >
            {/* Item Title */}
            <div className="font-[600] py-2 px-3 text-lg bg-[#F6F6F6] rounded-md">
              {item.name}
            </div>

            <div className="flex justify-between items-center py-2 px-3 flex-wrap gap-3">
              {/* Category Selection */}
              <div className="flex gap-2 flex-wrap">
                {item?.categoryOption && item?.categoryOption.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => handleCategoryChange(item?.name, cat)}
                    className={`px-3 py-1 text-sm border rounded-full transition ${
                      item.category === cat
                        ? "border-[#1876A9] text-[#1876A9]"
                        : "border-[#D8DAE5] text-[#333333]"
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              {/* Tailoring or Quantity */}
              {selectedService === "Tailoring" ? (
                <div className="flex gap-2 items-center">
                  <TailoringTypeDropdown
                    item={item}
                    options={item?.tailoringTypeOption}
                    selectedTypes={item?.tailoringType || []}
                    onChange={(newTypes) => {
                      handleTailoringTypeChange(item.name, newTypes);
                      
                    }}
                  />

                  {inCart ? (
                    <button
                      className="flex w-[80px] h-[30px] justify-center items-center  bg-[#FFDADA] text-[#D9534F] text-sm font-semibold rounded-full"
                      onClick={() => handleRemove(item)}
                    >
                      Remove
                    </button>
                  ) : (
                    <button
                      className="flex w-[80px] h-[30px] justify-center items-center  bg-[#DEEDF6] text-[#1876A9] text-sm font-semibold  rounded-full"
                      onClick={() => handleAdd(item)}
                    >
                      <FaPlus className="mr-1" /> Add
                    </button>
                  )}
                </div>
              ) : (
                <div className="flex items-center space-x-2">
                  <button
                    className="w-[26px] h-[26px] text-[13px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full"
                    onClick={() =>
                      item.weight > 0
                        ? handleQuantityChange(item.name, item.weight + 1)
                        : handleAdd(item)
                    }
                  >
                    <FaPlus />
                  </button>
                  <span className="text-sm font-semibold w-6 text-center">
                    {item.weight || 0}
                  </span>
                  <button
                    className="w-[26px] h-[26px] text-[13px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full"
                    onClick={() =>
                      handleQuantityChange(item.name, item.weight - 1)
                    }
                    disabled={item.weight === 0}
                  >
                    <FaMinus />
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
